import React from 'react';
import PropTypes from "prop-types";
import AboutUsHeader from "../Components/Headers/AboutUsHeader.js";
import ServiceInfoAreas from "../Components/InfoAreas/ServiceInfoAreas.js";

export default function Services({ headingbadge, infoAreas }) {

  return (
    <section className="py-2 bg-gray-50">
      <div className="container mx-auto px-4">
        {headingbadge && <AboutUsHeader {...headingbadge} />}
        
        <div className="flex flex-wrap -mx-4 items-start justify-center"> 
          {infoAreas.map((prop, key) => (
            <div 
              key={key} 
              className={`px-4 w-full md:w-${prop.width} info-card`}
            >
              <ServiceInfoAreas {...prop} />
            </div>
          ))}
        </div>
        
        <div className="flex justify-center mt-12 pb-12">
          <a
            href="services"
            className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-3 px-6 rounded-full shadow-md transition duration-300 ease-in-out"
          >
            All Services
          </a>
        </div>
        </div>
    </section>
  );
}

Services.defaultProps = {
  infoAreas: [],
  headingbadge: null,
};
Services.propTypes = {
  // prop to pass to the Heading2Badge component
  headingbadge: PropTypes.object,
  // an array of props that can be passed to the
  // InfoAreaIconTitleLinkColor component
  infoAreas: PropTypes.arrayOf(PropTypes.object),
};
